import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';
import rootReducer from '../reducers';

const composeEnhancers = composeWithDevTools({
  // TODO: check options
  // Specify name here, actionsBlacklist, actionsCreators and other options if needed
  maxAge: 1000,
});

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
